import { Platform } from '@/utils/platform';
import { invoke } from '../../QTBridge';

export const buriedPoint = (data: { key: string; value: string }) => {
  if (Platform.isPOPO && Platform.isPC) {
    console.log(`call qt: BuriedPoint. data=${JSON.stringify(data)}`);
    invoke('BuriedPoint', data).catch((e) => console.error(e));
  }
};
